import { Button, FormControl, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


function Group_crud({ setFetchAgain }) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();
    
    const [groupName, setGroupName] = useState("");
    const [level, setLevel] = useState('');
    const [teacher, setTeacher] = useState("");
    const [groupType, setGroupType] = useState("");
    const [numberOfStudents, setNumberOfStudents] = useState(0);
    const [picLoading, setPicLoading] = useState(false);

    const { user } = ChatState();

    const [fetchLevelAgain, setFetchLevelAgain] = useState(true);
	const [levelTable, setLevelTable] = useState([]);
	const [teacherTable, setTeacherTable] = useState([]);

	useEffect(() => {
		if(fetchLevelAgain === true || user!=undefined)
		{
		getAllLevels();
		getAllTeachers();
		setFetchLevelAgain(false);
		}
	}, [fetchLevelAgain,user])

	async function getAllLevels() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/level`, config)



			setLevelTable(data)



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
	}
	async function getAllTeachers() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/teacher`, config)



			setTeacherTable(data)



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
	}


    const openModal = () => {
      
        setGroupName("");
        setLevel("");
        setTeacher("");
        setGroupType("");
        setNumberOfStudents(0)
        onOpen()
    }
    const newGroup = async () => {

        if (!groupName || !level || !teacher || !groupType) {
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
            await axios.post(
                "/api/group",
                {
                    
                    groupName,
                    level,
                    teacher,
                    groupType,
                    numberOfStudents
                },
                config
            );
            toast({
                title: "Erfolgreich hinzugefügt",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });


            setFetchAgain(true);
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }
        onClose()
    };








    return <>
        <Button bg='gray.50' className="p-2" onClick={() => { openModal() }}><i className="fa-solid fa-plus text-blue-400 mr-2" ></i>Nouvel Group</Button>
        <Modal

            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent m='auto'>
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-users-line text-2xl mr-2"></i>Group</ModalHeader>
					<ModalBody pb={6}>


						<div className="mr-4">


							<FormControl mt={4}>
								<Input placeholder='Nom du groupe' id='groupeName' value={groupName}
									onChange={(e) => setGroupName(e.target.value)} />
							</FormControl>

							<FormControl mt={4}>
								<select defaultValue={level!==''?level:"def"} className="w-full border p-2" onChange={(e) => { setLevel(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Niveaux</option>
									{
										levelTable.map((level) => {
											return <option value={level.levelName}>{level.levelName}</option>
										})
									}
								</select>
							</FormControl>

							<FormControl mt={4}>

								<select defaultValue={teacher!==""?teacher:"def"} className="w-full border p-2" onChange={(e) => { setTeacher(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Professeur</option>
									{
										teacherTable.map((teacher) => {
											return <option value={teacher.teacherName}>{teacher.teacherName}</option>
										})
									}
								</select>
							</FormControl>
							<FormControl mt={4}>

								<select defaultValue={groupType!==""?groupType:"def"} className="w-full border p-2" onChange={(e) => { setGroupType(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Type</option>
									<option value="Présentiel">Présentiel</option>
									<option value='Hybride'>Hybride</option>
								</select>
							</FormControl>





						</div>


					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={newGroup}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
        </Modal>
    </>
}

export default Group_crud